import React from "react"

import styles from "./AstuteRequestConfirmProceedModal.AstuteCCPDeclaration.module.scss"

const AstuteCCPDeclarationDetails = (passThroughProps) => (
  <details className={styles.astuteCCPDeclaration} {...passThroughProps}>
    <summary>
      <small>View Astute CCP Declaration</small>
    </summary>

    <p>I declare that:</p>

    <p>I am an authorised user as defined in the Intermediary Agreement concluded with the Financial Services Exchange (Pty) Ltd, trading as Astute, and consider myself bound by the terms and conditions of the Intermediary agreement with Astute relating to the use of the Astute Systems.</p>

    <p><strong>I warrant and guarantee that the information provided by me for the purposes of the Digital Consent is that of the client (data subject) whose information is being requested and have dually confirmed such information and contact details belonging to the said client (data subject).</strong></p>

    <p>For the purposes of the Long-Term Insurance Act, client means the investor or policy owner. I am aware that the information accessed is private and confidential and may only be used for authorised purposes and that any breach of confidentiality could result in disciplinary steps or legal action being taken against me and that access to Astute services may be suspended or terminated at any time.</p>

    <p>I indemnify Astute, or any provider of content via Astute, against any action, which may be taken against Astute or any such content provider, by any natural or legal person, as well as against any damage or loss, including interest or legal costs incurred by Astute or any Content Provider as a result of such action, damage or loss which Astute or the Content Provider may suffer or incur as a result of the unauthorised use of the information accessed.</p>

    <p><small>Declaration last updated in Wealthbit: <time dateTime="2023-04-05">5 April, 2023</time></small></p>
  </details>
)

const AstuteCCPProceedDisclaimer = (passThroughProps) => (
  <small {...passThroughProps}>
    Requesting Astute reports incur a cost to your Astute profile. If you would like to proceed click 'Accept & Continue' above. By continuing, you accept the Astute CCP Declaration below. If a request fails for whatever reason you can retry the request with no additional charge. You can sign in to your Astute profile to view CCP requests and charges.
  </small>
)

export { AstuteCCPDeclarationDetails, AstuteCCPProceedDisclaimer }
